import { h, Host, } from "@stencil/core";
export class GxgTree {
    constructor() {
        this.checkbox = true;
        this.checked = false;
        this.opened = true;
        this.toggleCheckboxes = false;
        this.multiSelection = false;
    }
    /*
  INDEX:
  1.OWN PROPERTIES
  2.REFERENCE TO ELEMENTS
  3.STATE() VARIABLES
  4.PUBLIC PROPERTY API | WATCH'S
  5.EVENTS (EMIT)
  6.COMPONENT LIFECYCLE METHODS
  7.LISTENERS
  8.PUBLIC METHODS API
  9.LOCAL METHODS
  10.RENDER() FUNCTION
  */
    // 1.OWN PROPERTIES //
    masterTree = false;
    // 2. REFERENCE TO ELEMENTS //
    el;
    ulTree;
    // 5.EVENTS (EMIT) //
    treeItemStateChanged;
    // 6.COMPONENT LIFECYCLE METHODS //
    componentWillLoad() {
        this.initialConfig();
        this.evaluateIsMasterTree();
    }
    // 7.LISTENERS //
    checkboxToggledHandler(e) {
        const itemData = e.detail;
        if (this.masterTree) {
            this.emitTreeItemNewState(itemData, "checkboxToggled");
        }
    }
    doubleClickedHandler(e) {
        const itemData = e.detail;
        if (this.masterTree) {
            this.emitTreeItemNewState(itemData, "doubleClicked");
        }
    }
    selectionChangedHandler(e) {
        //Unselect all items, except the one that triggered this event. This action should be done once, by the master tree.
        const allChildren = this.el.querySelectorAll("gxg-tree-item");
        if ((this.masterTree && this.multiSelection && !e.detail.ctrl) ||
            (this.masterTree && !this.multiSelection)) {
            Array.from(allChildren).forEach((item) => {
                if (item !== e.detail.ref) {
                    item.selected = false;
                }
            });
        }
        const itemData = e.detail;
        if (this.masterTree) {
            this.emitTreeItemNewState(itemData, "selectionChanged");
        }
    }
    toggleIconClickedHandler(e) {
        const itemData = e.detail;
        if (this.masterTree) {
            this.emitTreeItemNewState(itemData, "toggleIconClicked");
        }
    }
    // 8.PUBLIC METHODS API //
    /**
     * Returns an array of the selected tree-items, providing the id, checked status, selected status, and label.
     */
    async getCheckedItems(idsArray) {
        const allTreeItems = Array.from(this.el.querySelectorAll("gxg-tree-item"));
        const checkedTreeItems = [];
        if (idsArray?.length) {
            idsArray.forEach((id) => {
                const found = allTreeItems.find((item) => id === item.id);
                found &&
                    checkedTreeItems.push({
                        id: found.id,
                        label: found.label,
                        checked: found.checked,
                        selected: found.selected,
                    });
            });
        }
        else {
            allTreeItems.forEach((item) => {
                item.checked &&
                    checkedTreeItems.push({
                        id: item.id,
                        label: item.label,
                        checked: item.checked,
                        selected: item.selected,
                    });
            });
        }
        return checkedTreeItems;
    }
    /**
     * Returns an array of the selected tree-items, providing the id, checked status, selected status, and label.
     */
    async getSelectedItems() {
        const selectedItems = [];
        const allItems = this.el.querySelectorAll("gxg-tree-item");
        if (allItems?.length) {
            Array.from(allItems).forEach((item) => {
                if (item.selected) {
                    selectedItems.push({
                        id: item.id,
                        label: item.label,
                        checked: item.checked,
                        selected: item.selected,
                    });
                }
            });
        }
        return selectedItems;
    }
    /**
     * @param ids: An array id the tree items to be toggled.
     * @param open: A boolean indicating that the tree item should be opened or closed. (optional)
     * @description This method is used to toggle a tree-item by the tree-item id/ids.
     * @returns a boolean value indicating if the selected tree-item is open or not, after the method was called.
     */
    async toggleItems(ids, open) {
        if (!ids?.length) {
            return [];
        }
        const allTreeItems = Array.from(this.el.querySelectorAll("gxg-tree-item"));
        const toggledTreeItems = [];
        ids.forEach((id) => {
            const found = allTreeItems.find((item) => id === item.id);
            if (found && open === undefined) {
                found.opened = !found.opened;
            }
            else if (found && open && !found.opened) {
                found.opened = true;
            }
            else if (found && !open && found.opened) {
                found.opened = false;
            }
            if (found) {
                toggledTreeItems.push({
                    id: found.id,
                    opened: found.opened,
                });
            }
        });
        return toggledTreeItems;
    }
    // 9.LOCAL METHODS //
    /**
     * This method evaluates if this tree is the master tree
     */
    evaluateIsMasterTree = () => {
        const grandFather = this.el.parentElement?.parentElement;
        if (grandFather === undefined || grandFather.nodeName !== "GXG-TREE") {
            this.masterTree = true;
        }
    };
    initialConfig = () => {
        const parent = this.el.parentElement;
        if (parent?.tagName === "GXG-TREE-ITEM") {
            const treeItem = parent;
            this.checkbox =
                treeItem.checkbox !== undefined ? treeItem.checkbox : this.checkbox;
            this.checked =
                treeItem.checked !== undefined ? treeItem.checked : this.checked;
            this.opened =
                treeItem.opened !== undefined ? treeItem.opened : this.opened;
            this.toggleCheckboxes =
                treeItem.toggleCheckboxes !== undefined
                    ? treeItem.toggleCheckboxes
                    : this.toggleCheckboxes;
        }
    };
    /**
     * @description This functions is supposed to be called from any of the listeners that are attached to the tree-item events that are emitted when the state changes (toggleIconClicked, selectionChanged, checkboxToggled). When an item state is changed, this function emits the update item data, so that the host can update the tree model, if any, if desired.
     */
    emitTreeItemNewState = (itemData, emittedBy) => {
        this.treeItemStateChanged.emit({ itemData, emittedBy: emittedBy });
    };
    // 10.RENDER() FUNCTION //
    render() {
        return (h(Host, null, h("div", { class: {
                tree: true,
            } }, h("ul", { ref: (el) => (this.ulTree = el) }, h("slot", null)))));
    }
    static get is() { return "gxg-tree"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["gxg-tree.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["gxg-tree.css"]
        };
    }
    static get properties() {
        return {
            "checkbox": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set this attribute if you want all the items to have a checkbox."
                },
                "attribute": "checkbox",
                "reflect": false,
                "defaultValue": "true"
            },
            "checked": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set this attribute if you want all the items to be checked by default."
                },
                "attribute": "checked",
                "reflect": true,
                "defaultValue": "false"
            },
            "opened": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set this attribute if you want all the items to be opened by default."
                },
                "attribute": "opened",
                "reflect": false,
                "defaultValue": "true"
            },
            "toggleCheckboxes": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set this attribute if you want all the items checkboxes to be toggled when the parent tree item checkbox is toggled."
                },
                "attribute": "toggle-checkboxes",
                "reflect": false,
                "defaultValue": "false"
            },
            "multiSelection": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set this attribute if you want to allow multi selection of the items. This property should only be set on the master tree."
                },
                "attribute": "multi-selection",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "treeItemStateChanged",
                "name": "treeItemStateChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "TreeItemNewStateEmitted",
                    "resolved": "{ itemData: GxgTreeItemData; emittedBy: string; }",
                    "references": {
                        "TreeItemNewStateEmitted": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/tree/gxg-tree.tsx",
                            "id": "src/components/tree/gxg-tree.tsx::TreeItemNewStateEmitted"
                        }
                    }
                }
            }];
    }
    static get methods() {
        return {
            "getCheckedItems": {
                "complexType": {
                    "signature": "(idsArray?: (string | number)[]) => Promise<GxgTreeItemSelectedData[]>",
                    "parameters": [{
                            "name": "idsArray",
                            "type": "(string | number)[]",
                            "docs": ""
                        }],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "GxgTreeItemSelectedData": {
                            "location": "import",
                            "path": "../tree-item/gxg-tree-item",
                            "id": "src/components/tree-item/gxg-tree-item.tsx::GxgTreeItemSelectedData"
                        }
                    },
                    "return": "Promise<GxgTreeItemSelectedData[]>"
                },
                "docs": {
                    "text": "Returns an array of the selected tree-items, providing the id, checked status, selected status, and label.",
                    "tags": []
                }
            },
            "getSelectedItems": {
                "complexType": {
                    "signature": "() => Promise<GxgTreeItemData[]>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "GxgTreeItemData": {
                            "location": "import",
                            "path": "../tree-item/gxg-tree-item",
                            "id": "src/components/tree-item/gxg-tree-item.tsx::GxgTreeItemData"
                        }
                    },
                    "return": "Promise<GxgTreeItemData[]>"
                },
                "docs": {
                    "text": "Returns an array of the selected tree-items, providing the id, checked status, selected status, and label.",
                    "tags": []
                }
            },
            "toggleItems": {
                "complexType": {
                    "signature": "(ids: string[], open?: boolean) => Promise<ToggledGxgTreeItem[]>",
                    "parameters": [{
                            "name": "ids",
                            "type": "string[]",
                            "docs": ": An array id the tree items to be toggled."
                        }, {
                            "name": "open",
                            "type": "boolean",
                            "docs": ": A boolean indicating that the tree item should be opened or closed. (optional)"
                        }],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "ToggledGxgTreeItem": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/tree/gxg-tree.tsx",
                            "id": "src/components/tree/gxg-tree.tsx::ToggledGxgTreeItem"
                        }
                    },
                    "return": "Promise<ToggledGxgTreeItem[]>"
                },
                "docs": {
                    "text": "",
                    "tags": [{
                            "name": "param",
                            "text": "ids : An array id the tree items to be toggled."
                        }, {
                            "name": "param",
                            "text": "open : A boolean indicating that the tree item should be opened or closed. (optional)"
                        }, {
                            "name": "description",
                            "text": "This method is used to toggle a tree-item by the tree-item id/ids."
                        }, {
                            "name": "returns",
                            "text": "a boolean value indicating if the selected tree-item is open or not, after the method was called."
                        }]
                }
            }
        };
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "checkboxToggled",
                "method": "checkboxToggledHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "doubleClicked",
                "method": "doubleClickedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "selectionChanged",
                "method": "selectionChangedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "toggleIconClicked",
                "method": "toggleIconClickedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=gxg-tree.js.map
